var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 39,
    viewBox: "0 0 33 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4471 27.0097L22.5872 22.6312L18.7323 3.01566V0.514771H14.0187V3.01566H14.0024L14.0001 3.0278L0 12.2658V20.8352H4.71362V16.7347H11.3064L7.62371 35.4787C7.31071 36.5025 7.0873 37.5626 6.96978 38.6515H7.00004V38.6548H11.7125L12.0034 37.1721C12.9913 33.4555 15.579 30.3379 19.029 28.5155L21.0211 38.6548H25.7347L23.4459 27.0108L23.4471 27.0097ZM6.77198 12.2658L12.9901 8.16307L12.1837 12.2658H6.77198ZM14.1444 26.2761L16.3668 14.9674L18.1331 23.9583C16.7007 24.5761 15.3626 25.3582 14.1444 26.2761ZM33 23.5336L31.1476 27.6263C30.7252 27.4796 30.2935 27.3517 29.8549 27.2413L31.2337 22.9842C31.8341 23.1408 32.424 23.324 33 23.5325V23.5336ZM26.1594 22.3344C26.4072 22.3344 26.6527 22.3433 26.8994 22.3521L26.6981 26.8001C26.5189 26.7935 26.3409 26.7868 26.1605 26.7868C25.4519 26.7868 24.7561 26.8376 24.0754 26.9314L23.2935 22.5385C24.229 22.405 25.1866 22.3344 26.1605 22.3344H26.1594ZM30.3191 22.7702L29.187 27.0913C28.5994 26.9722 27.9978 26.8894 27.3858 26.8398L27.8466 22.4083C28.6878 22.4778 29.5116 22.5992 30.318 22.7691L30.3191 22.7702Z",
    fill: "url(#paint0_linear_50_655)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_655",
    x1: 0,
    y1: 19.5842,
    x2: 33,
    y2: 19.5842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DB34A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small_logo.a1e8e67e82ee108f00b429b977a1e232.svg";
export { ForwardRef as ReactComponent };